import BaseModel from "../core/BaseModel";
export default class SuppliesEquipmentWarningModel extends BaseModel {
  constructor() {
    super(
      {
        name: "supplies_equipment_warning",
        tableName: "supplies_equipment_warning",
        label: "Danh Sách Vật tư/Thiết bị sắp hết hạn",
        display_key: 'name',
      },
      {
        stt: {
          name: "stt",
          label: "STT",
          class: "xs-col",
          computed: (data, index) => {
            data.stt = index + 1;
          },
        },
        id: {
          name: "id",
          type: "Uuid",
          label: "ID",
          primaryKey: true,
          display: false,
        },
        type: {
          name: "type",
          label: "Loại",
          type: "Selection",
          custom: "SelectionText",
          options: [
            { value: 'supplies', label: "Vật tư" },
            { value: 'equipment', label: "Thiết bị" },
          ],
          filter: {
            type: "select",
            optionLabel: "label",
            optionKey: "value",
            match: "equals",
          },
        },
        avatar : {
          name: 'avatar',
          type: "Image",
          label: 'Ảnh',
        },
        name: {
          name: "name",
          type: "String",
          label: "Tên",
          filter: { type: "input", match: "contains" },
        },
        contractor_name: {
          name: "contractor_name",
          type: "String",
          label: "Nhà thầu",
          filter: { type: "input", match: "contains" },
        },
        text_warning: {
          name: "text_warning",
          type: "CustomUrl",
          label: "Nội dung cảnh báo",
          computed: (data) => {
            data.text_warning = '';
          },
        },
      }
    );
  }
}
